var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phi-tabs"},[(_vm.type == 'scrollable')?_c('vue-scroll',{attrs:{"ops":_vm.scrollerOptions}},[_vm._t("default")],2):_c('div',{staticClass:"fixed-slot"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }